export default __webpack_public_path__ + "static/media/share.c789d024.svg";